"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var strings_1 = require("./strings");
exports.PERMISSION_STATUSES = [strings_1.PENDING, strings_1.GRANTED, strings_1.REJECTED];
